import React, { FC, useState } from "react";
import { FormControlLabel } from "@mui/material";

import { Switch, Stack, Typography } from "@components/base";

const Switches: FC = () => {
  const [checked, setChecked] = useState(true);

  return (
    <Stack spacing={4}>
      <Typography variant="h2">Switches</Typography>
      <Stack spacing={2}>
        <Typography variant="subtitle2">Default</Typography>
        <Switch checked={checked} onChange={() => setChecked(!checked)} />
      </Stack>
      <Stack spacing={2}>
        <Typography variant="subtitle2">Small</Typography>
        <Switch
          checked={checked}
          onChange={() => setChecked(!checked)}
          size="small"
        />
      </Stack>
      <Stack spacing={2}>
        <Typography variant="subtitle2">With label</Typography>
        <FormControlLabel
          control={
            <Switch checked={checked} onChange={() => setChecked(!checked)} />
          }
          label="Switch with label"
        />
      </Stack>
      <Stack spacing={2}>
        <Typography variant="subtitle2">Disabled</Typography>
        <Switch disabled />
      </Stack>
    </Stack>
  );
};

export default Switches;
